<template>
	<div class="nb-pager-selection">

		<div class="title-area clearfix">
			
			<span slot="title">
				{{activeTheme.name?"#"+activeTheme.id+" "+activeTheme.name:"请选择专题样式..."}}
			</span>

			<button class="btn btn-default btn-sm ml15" @click="show=!show">
				<span v-if="show">
            <i class="fa fa-angle-up"></i>
				收起
          </span>
				<span v-else>
            <i class="fa fa-angle-down"></i>
				选择
        </span>

			</button>
		</div>
		<NbExpanding>
			<div v-show="show">
				<div class="content-area">
					<div class="row">

						<div class="col-xs-12">

							<div v-for="theme in themeList"
							     class="p10 mt10 br4 cursor border"
							     @click.stop.prevent="clickItem(theme)"
							     :class="{'bg-white':theme.id !== activeTheme.id,'bg-azure':theme.id === activeTheme.id}"
							>

								<div class="row">

									<div class="col-sm-12">
										<div class="media">
											<div class="pull-left">
											</div>
											<div class="media-body">
												<div>
													<span class="f15">{{theme.name}}</span>
												</div>
												<div class="mv5">
													{{theme.description}}
												</div>
												<div class="mv5">
													<span>编号：{{theme.id}}</span>
													<a href="javascript:void(0)" @click.stop.prevent="previewClick(theme)"> 点击这里预览 </a>
												</div>

											</div>
										</div>
									</div>

								</div>


							</div>


						</div>

					</div>
				</div>
			</div>

		</NbExpanding>


	</div>

</template>
<script>
	import Pager from "../../../common/model/base/Pager";
	import Theme from "../../../common/model/lover/Theme";
	import NbExpanding from '../../../common/widget/NbExpanding'
	export default{
		data(){
			return {
				show: false
			}
		},
		props: {
			activeTheme: {
				type: Theme,
				required: true
			}
		},
		computed: {
			"themeMap"(){
				return this.$store.state.themeMap;
			},
			"themeList"(){
				return this.$store.state.themeList;
			}
		},
		watch: {
			"activeTheme.id"(newVal, oldVal){
				this.updateActiveTheme();
			}
		},
		methods: {
			clickItem(theme){
				this.activeTheme.render(theme);
				this.show = false;
			},
			previewClick(theme){
				window.open("/" + theme.getPreviewLocation());
			},
			updateActiveTheme(){
				//如果传过来的activeTheme只有id没有其他内容，我们将要负责去获取其详细内容。
				if (this.activeTheme.id && !this.activeTheme.title) {

					this.activeTheme.render(this.themeMap[this.activeTheme.id]);
				}
			}
		},
		components: {
			NbExpanding
		},
		mounted(){
			this.updateActiveTheme();
		}
	}
</script>



// WEBPACK FOOTER //
// Selection.vue?6ced4eaf